import data from "../../data/index.json";
import { useNavigate } from "react-router-dom";

export default function MySkills() {

   const navigate = useNavigate();


  return (
    <section className="skills--section" id="informatives">
      <div className="portfolio--container">
        {/* <p className="section--title">Nossas habilidades</p> */}
        <h2 className="skills--section--heading">Informativos</h2>
      </div>
      <div className="skills--section--container">
        {data?.informatives?.map((item, index) => (
          <div key={index} className="skills--section--card" onClick={() => navigate(item.link)}>
            <div className="skills--section--img">
              <img src={item.src} alt="Product Chain" />
            </div>
            <div className="skills--section--card--content">
              <h3 className="skills--section--title">{item.title}</h3>
              <p className="skills--section--description">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
